import { message } from "antd";
import { EventsApiService } from "features/events/api/events-api.service";
import { useEffect, useState } from "react";

import { BoothtargetTable } from "./booth-target-table";

export const BoothTargetValueView = ({ id }: any) => {
   
    const [state,setSate]=useState<any>('')
    const payload:any={
        EventId:id,
        TargetValue:null
    }
    const fetchdata=async()=>{
      try {
        const response=await EventsApiService().updatetarget(payload) 
            setSate(response)
      } catch (error:any) {
        message.error(error);
      }
    }
    
    useEffect(()=>{
      fetchdata()
    },[])
    
return (
        <>
            <BoothtargetTable
                data={state}
                refetch={fetchdata}
            />
        </>
    )
}